export const ImageType = {
  Picture: 'picture',
  Icon: 'icon',
}

export const ImageShape = {
  Circle: 'circle',
  Rectangle: 'rectangle',
}

export const QuizType = {
  WahrFalsch: 'wahr-falsch',
  Selbsttest: 'selbsttest',
}

export const DisabledState = {
  Success: 'success',
  Error: 'error',
  ErrorMuted: 'error--muted',
  Default: 'default',
}
